import { render } from "./AsociarProfFact.vue?vue&type=template&id=87c59b3a"
import script from "./AsociarProfFact.vue?vue&type=script&lang=js"
export * from "./AsociarProfFact.vue?vue&type=script&lang=js"

import "../assets/general.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__